import type { CustomerStatusSummary } from 'services/customerStatusService';
import type { BaseTerritoryData } from 'services/basesServices';

export const CUSTOMER_STATUS_REQUEST = '@customerStatus/REQUEST' as const;
export const CUSTOMER_STATUS_SUCCESS = '@customerStatus/SUCCESS' as const;
export const CUSTOMER_STATUS_FAILURE = '@customerStatus/FAILURE' as const;
export const CUSTOMER_STATUS_INVALIDATE = '@customerStatus/INVALIDATE' as const;

export type CustomerStatusSuccessPayload = {
  siteCode: string;
  summary: CustomerStatusSummary;
  territoryByBase: Record<string, BaseTerritoryData>;
  failedBases: string[];
  summaryFailed: boolean;
  fetchedAt: number;
};

type RequestAction = {
  type: typeof CUSTOMER_STATUS_REQUEST;
  payload: { siteCode: string };
};
type SuccessAction = {
  type: typeof CUSTOMER_STATUS_SUCCESS;
  payload: CustomerStatusSuccessPayload;
};
type FailureAction = {
  type: typeof CUSTOMER_STATUS_FAILURE;
  payload: { siteCode: string };
};
type InvalidateAction = { type: typeof CUSTOMER_STATUS_INVALIDATE };

export const customerStatusRequest = (siteCode: string): RequestAction => ({
  type: CUSTOMER_STATUS_REQUEST,
  payload: { siteCode },
});

export const customerStatusSuccess = (
  payload: CustomerStatusSuccessPayload
): SuccessAction => ({
  type: CUSTOMER_STATUS_SUCCESS,
  payload,
});

export const customerStatusFailure = (siteCode: string): FailureAction => ({
  type: CUSTOMER_STATUS_FAILURE,
  payload: { siteCode },
});

export const customerStatusInvalidate = (): InvalidateAction => ({
  type: CUSTOMER_STATUS_INVALIDATE,
});

export type CustomerStatusAction =
  | RequestAction
  | SuccessAction
  | FailureAction
  | InvalidateAction;
